import { RoleRead } from "@/types/emr/role/role";
import { UserReadMinimal } from "@/types/user/user";

export enum FacilityOrganizationType {
  ROOT = "root",
  DEPT = "dept",
  TEAM = "team",
}

export enum DepartmentCodeSource {
  STANDARD = "standard",
  CUSTOM = "custom",
}

export interface FacilityOrganizationParent {
  id: string;
  name: string;
  description?: string;
  org_type: FacilityOrganizationType;
  level_cache: number;
  parent?: FacilityOrganizationParent;
}

export interface FacilityOrganizationBase {
  name: string;
  description: string;
  org_type: FacilityOrganizationType;
  department_code?: string | null;
  department_code_source?: DepartmentCodeSource | null;
  standard_department?: string | null;
}

export interface FacilityOrganizationRead extends FacilityOrganizationBase {
  id: string;
  parent?: FacilityOrganizationParent;
  active: boolean;
  level_cache: number;
  has_children: boolean;
  created_at: string;
  updated_at: string;
}

export interface FacilityOrganizationCreate extends FacilityOrganizationBase {
  facility: string;
  parent?: string;
  custom_department_code?: string | null;
}

export interface FacilityOrganizationUserRole {
  id: string;
  user: UserReadMinimal;
  role: RoleRead;
}
